export let selectedPackages = {
    packageCount: 0
};

export const api = {
    url: 'https://vue-package-manager.firebaseio.com/packages',
    suggestedPackagesUrl: 'https://vue-package-manager.firebaseio.com/suggestedPackages.json',
};